import { Component, OnInit } from '@angular/core';
import { MOI } from '../../enums/moi.enum';
import { SystemMessagesEnum } from '../../enums/system-messages.enum';
import { BiggerPictureMessagesService } from '../../services/bigger-picture-messages.service';
import { AppInjector } from '../../services/app-injector.service';
import { FormArray, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-base-component',
  templateUrl: './base-component.component.html',
  styleUrls: ['./base-component.component.scss']
})
export class BaseComponent implements OnInit {

  protected biggerPictureMessagesService: BiggerPictureMessagesService;

  moi = MOI;
  systemMessagesEnum = SystemMessagesEnum;

  constructor() {
    AppInjector.getInjector().subscribe((injector) => {
      this.biggerPictureMessagesService = injector.get(BiggerPictureMessagesService);
    });
  }

  ngOnInit() {
  }

  tranKey(moi: MOI, msgId: number | string, type = 'text'): string {
    return this.biggerPictureMessagesService.tranKey(moi, msgId, type);
  }

  asGroup(control: any): FormGroup {
    return control as FormGroup;
  }

  asControl(control: any): FormControl {
    return control as FormControl;
  }

  asArray(control: any): FormArray {
    return control as FormArray;
  }

}
